module.exports = __webpack_public_path__ + "static/media/sad-squint.b7066322.svg";